import React from "react";
import { Box, Typography, Fade } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const PageHeader = () => {
  const theme = useTheme();

  return (
    <Fade in timeout={800}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography 
          variant="h2" 
          component="h1" 
          sx={{ 
            fontWeight: 'bold',
            background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 2,
            fontSize: { xs: '2.5rem', md: '3.5rem' }
          }}
        >
          Live Market
        </Typography>
        <Typography 
          variant="h6" 
          color="text.secondary" 
          sx={{ maxWidth: 600, mx: 'auto', fontSize: { xs: '1rem', md: '1.25rem' } }}
        >
          Live prices from top scrap exchanges worldwide
        </Typography>
      </Box>
    </Fade>
  );
};

export default PageHeader;
